// TODO - copiato da Credit, adattare se necessario
export const TOOLBAR = 'toolbar/'
export const TRADUZIONI = 'traduzioni/'